<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Support Tickets</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="row">
				<div class="col-md-12">
					<div class="card card-primary card-outline">
						<div class="card-body">
							<h4>Tickets:</h4>
							<p v-if="tokens.length == 0">No Tickets</p>
							<div v-else class="list-group">
					 			<button @click="showDetails(token)" v-for="token in tokens" class="list-group-item list-group-item-action col-md-6"><b>Name:</b> {{token.name}} <b>Subject:</b> {{token.title}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    <div class="modal" tabindex="-1" role="dialog" id="detailsModal">
  		<div class="modal-dialog" role="document">
    		<div class="modal-content">
      		<div class="modal-header">
      			<h5 class="modal-title">Token Details</h5>
        		<button type="button" class="close" data-dismiss="modal" aria-label="Close">
          		<span aria-hidden="true">&times;</span>
        		</button>
      		</div>
      		<div class="modal-body">
      			<p><b>Name: </b>{{name}}</p>
      			<p><b>Email: </b>{{email}}</p>
      			<p><b>Phone: </b>{{phone}}</p>
      			<p><b>Created At: </b>{{created_at}}</p>
      			<p><b>Subject: </b>{{title}}</p>
      			<p><b>Description: </b>{{description}}</p>
      		</div>
      		<div class="modal-footer">
      			<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      			<button class="btn btn-primary" @click="attended">Attended</button>
      		</div>
      	</div>
      </div>
     </div>    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getTokens();
        },
        
        data(){
        	return {
        		tokens: [],
        		id: '',
        		name: '',
        		email: '',
        		phone: '',
        		title: '',
        		description: '',
        		created_at: ''
        	}
        },
        
        methods: {
        	getTokens(){
        		axios.post("/api/getTokens")
        		.then(response => {
        			this.tokens = response.data;
        		})
        	},
        	
        	showDetails(token){
        		this.id = token.id;
        		this.name = token.name;
        		this.email = token.email;
        		this.phone = token.phone;
        		this.title = token.title;
        		this.description = token.description;
        		this.created_at = token.created_at;
        		$("#detailsModal").modal("show");
        	},
        	
        	attended(){
        		axios.post("/api/attended", {id: this.id})
        		.then(() => {
        			toast.fire({
      		      type: 'success',
                title: 'Marked as Attended'
            	});
            	this.getTokens();
        		})
        		.catch(() => {
        			toast.fire({
      		      type: 'error',
                title: 'Marking Failed'
            	});
        		})
        	}
        }
    }
</script>
